import { render, staticRenderFns } from "./garantiaexamen.vue?vue&type=template&id=64e48bcd&"
import script from "./garantiaexamen.vue?vue&type=script&lang=js&"
export * from "./garantiaexamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports